import i18n from 'i18next';

/**
 * Text for a plain-rendered cell value: primitives stringify as-is (booleans as
 * the localized Yes/No labels, like the legacy datagrid's BOOLEAN formatting),
 * objects contribute their `.label`, and arrays (isArray columns — e.g.
 * CODE_LIST / ENTITY / ENUM multi-values) join their items with ', ' like the
 * legacy datagrid's array formatting.
 *
 * Shared by `renderCell` (PLAIN fallback) and `buildClipboardTsv` so the
 * copied text always matches the rendered cell.
 */
export const toPlainLabel = (value: unknown): string => {
  if (typeof value === 'boolean') {
    return value ? i18n.t('general.labels.yes') : i18n.t('general.labels.no');
  }
  if (Array.isArray(value)) {
    return value
      .map(toPlainLabel)
      .filter((label) => label !== '')
      .join(', ');
  }
  if (typeof value === 'object' && value !== null) {
    return 'label' in value ? String((value as Record<string, unknown>).label ?? '') : '';
  }
  return String(value ?? '');
};
